import { Component } from '@angular/core';

@Component({
  templateUrl: './send-grid-index.component.html',
  styleUrls: ['./send-grid-index.component.scss'],
  standalone: false,
})
export class SendGridIndexComponent {}
